"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFirstStringMatchingRegex = exports.isLaterVersion = exports.sortLatestFirst = exports.isApplicationVersion = exports.isCurrentVersion = exports.isLatestVersion = exports.coreVersionPattern = exports.legacyPattern = exports.dateFormat = void 0;
const lodash_1 = __importDefault(require("lodash"));
const date_fns_1 = require("date-fns");
const validation_1 = require("../validator/validation");
exports.dateFormat = 'yyyy-MM-dd';
exports.legacyPattern = /^\d+$/;
exports.coreVersionPattern = /^\d{4,}-\d{2}-\d{2}\.\d+$/;
exports.isLatestVersion = (0, validation_1.isLiteral)('latest');
exports.isCurrentVersion = (0, validation_1.isLiteral)('current');
const isLegacyVersion = validation_1.isString.which((0, validation_1.satisfiesCondition)(s => exports.legacyPattern.test(s)));
const isCoreVersion = validation_1.isString.which((0, validation_1.satisfiesCondition)(s => exports.coreVersionPattern.test(s)));
exports.isApplicationVersion = (0, validation_1.isSomeOf)(isCoreVersion, isLegacyVersion);
const sortNumerically = (n1, n2) => Number(n2) - Number(n1);
const sortByDate = (d1, d2) => {
    return d2.getTime() - d1.getTime();
};
const sortByLegacyVersion = (lv1, lv2) => sortNumerically(lv1, lv2);
const sortByNewCoreVersion = (s1, s2) => {
    const firstDate = lodash_1.default.head(s1.split('.'));
    const secondDate = lodash_1.default.head(s2.split('.'));
    if (lodash_1.default.isNil(firstDate) && lodash_1.default.isNil(secondDate))
        return 0;
    else if (lodash_1.default.isNil(firstDate))
        return -10;
    else if (lodash_1.default.isNil(secondDate))
        return 10;
    const d1 = (0, date_fns_1.parse)(firstDate, exports.dateFormat, 0);
    const d2 = (0, date_fns_1.parse)(secondDate, exports.dateFormat, 0);
    const comp = sortByDate(d1, d2);
    if (comp !== 0) {
        return comp;
    }
    const firstRelease = lodash_1.default.last(s1.split('.'));
    const secondRelease = lodash_1.default.last(s2.split('.'));
    return sortNumerically(firstRelease, secondRelease);
};
const sortLatestFirst = (t1, t2) => {
    exports.isApplicationVersion.validate(t1);
    exports.isApplicationVersion.validate(t2);
    const t1new = isCoreVersion(t1);
    const t2new = isCoreVersion(t2);
    if (t1new && t2new) {
        return sortByNewCoreVersion(t1, t2);
    }
    else if (t1new) {
        return -1;
    }
    else if (t2new) {
        return 1;
    }
    return sortByLegacyVersion(t1, t2);
};
exports.sortLatestFirst = sortLatestFirst;
const isLaterVersion = (t1, t2) => {
    exports.isApplicationVersion.validate(t1);
    exports.isApplicationVersion.validate(t2);
    const array = [t1, t2].sort(exports.sortLatestFirst);
    return lodash_1.default.head(array) === t1;
};
exports.isLaterVersion = isLaterVersion;
const findFirstStringMatchingRegex = (array, regexes) => {
    return array.find(arrayElement => {
        const possibleString = regexes.find(pattern => pattern.test(arrayElement));
        return !lodash_1.default.isNil(possibleString);
    });
};
exports.findFirstStringMatchingRegex = findFirstStringMatchingRegex;
//# sourceMappingURL=ApplicationVersionConfig.js.map